<span class="value">{{ translation }}</span>

